import * as React from "react";
const SvgSortingDown = (props) => /* @__PURE__ */ React.createElement("svg", { stroke: "currentColor", fill: "currentColor", strokeWidth: 0, viewBox: "0 0 24 24", height: 16, width: 16, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 16h-3V4h-2v12h-3l4 4z" }));
export default SvgSortingDown;
